<template>
	<div>
		<label for="job_number" class="uk-form-label standard-text" >Job Number</label>

		<div class="uk-form-controls">
			<input id="job_number" type="text" name="job_number" class="uk-input" v-model="val" @keyup="updateValue" />
		</div>
	</div>
</template>

<script>
    export default {
        name: "JobNumberField",

		props:{
            value:String
		},

        components: {},

        data() {
            return {
                val:""
			};
        },

        mounted() {
			this.val = this.value;
			this.updateValue();
        },

        methods: {
            updateValue(){
                let cleanNumber = this.val.replace(/\-/g, "");
                if(cleanNumber.length < 5){
                    this.val = cleanNumber;
                    return;
                }
                if(cleanNumber.length < 7){
                    this.val = cleanNumber.substr(0, 4) + "-" +
                        cleanNumber.substr(4);
                    return;
                }

                this.val = cleanNumber.substr(0, 4) + "-" +
                    cleanNumber.substr(4, 2) + "-" + cleanNumber.substr(6);
			}
		}
    }
</script>
